<template>
  <div class="add-initial-contract">
    <div class="add-initial-contract__content" v-loading="loading">
      <div>
        <div class="add-initial-contract__title">Создание изначального договора</div>
        <div
          class="form-input"
          :class="{
            'form-input--full': form.clientId,
            'form-input--error': errors.clientId,
          }"
          @click="openDialogAddingInitialClient('clientId')"
        >
          <input :value="form.clientId && form.clientId.name" type="text" readonly />
          <span class="form-input__label">Рекламодатель*</span>
          <template v-if="errors.clientId && errors.clientId.length">
            <div v-for="error in errors.clientId" :key="error" class="form-input__error">
              {{ error }}
            </div>
          </template>
        </div>
        <div
          class="form-input"
          :class="{
            'form-input--full': form.contractorId,
            'form-input--error': errors.contractorId,
          }"
          @click="openDialogAddingInitialClient('contractorId')"
        >
          <input :value="form.contractorId && form.contractorId.name" type="text" readonly />
          <span class="form-input__label">Исполнитель*</span>
          <template v-if="errors.contractorId && errors.contractorId.length">
            <div v-for="error in errors.contractorId" :key="error" class="form-input__error">
              {{ error }}
            </div>
          </template>
        </div>
        <div
          class="form-input"
          :class="{
            'form-input--full': form.number,
            'form-input--error': errors.number,
          }"
        >
          <input v-model="form.number" type="text" required />
          <span class="form-input__label">Номер договора*</span>
          <template v-if="errors.number && errors.number.length">
            <div v-for="error in errors.number" :key="error" class="form-input__error">
              {{ error }}
            </div>
          </template>
        </div>
        <div class="form-input">
          <SingleDatePicker
            ref="contractDate"
            class="add-initial-contract__date-picker"
            title="Дата заключения*"
            :value="form.date"
            @changeDates="setForm({ formName: 'date', formValue: $event.startDate })"
          />
          <template v-if="errors.date && errors.date.length">
            <div v-for="error in errors.date" :key="error" class="form-input__error">
              {{ error }}
            </div>
          </template>
        </div>
        <ContractTypeForm
          :form="form"
          :additionalAgreementOptions="additionalAgreementOptions"
          @changeValue="changeContractTypeForm"
        />
        <div
          class="form-input"
          :class="[{ 'form-input--full': form.amount }, { 'form-input--error': errors.amount }]"
        >
          <input
            :value="form.amount"
            @input="setForm({ formName: 'amount', formValue: $event.target.value })"
            type="number"
            required
          />
          <span class="form-input__label">Сумма договора</span>
          <template v-if="errors.amount && errors.amount.length">
            <div v-for="error in errors.amount" :key="error" class="form-input__error">
              {{ error }}
            </div>
          </template>
        </div>
        <!-- <Selector
          ref="vat"
          class="add-initial-contract__selector add-initial-contract__input form-input"
          required
          :title="'с НДС / без НДС'"
          :options="Object.keys(VatType).map((key) => ({ id: key, name: VatType[key] }))"
          :default-select-item-id="form.VatIncluded"
          :select-fitrst-item="false"
          @handleChange="(val) => setForm({formName: 'VatIncluded', formValue: val})"
        /> -->
      </div>
      <div class="add-initial-contract__group-btns">
        <template v-if="errors.global && errors.global.length">
          <div v-for="error in errors.global" :key="error" class="form-input__error">
            {{ error }}
          </div>
        </template>
        <div class="add-initial-contract__btns-wrapper">
          <ButtonElement
            @click-button="createInitialContract"
            text="Отправить"
            class="add-initial-contract__save-btn"
            :disabled="isBtnDisabled"
          />
          <ButtonElement
            @click-button="closeDialog"
            class="add-initial-contract__cancel-btn button--empty"
            :text="'Отменить'"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ButtonElement from '@/components/elements/ButtonElement';
import formValidate from '@/mixin/formValidate';
import Selector from '@/components/sort/Selector';
import numberWithSpaces from '@/mixin/numberWithSpaces';
import {
  ContractType,
  VatType,
  ContractVariant,
  ContractTypeKeys,
  AgentActingForPublisherTypeKeys,
} from '@/utils/contracts';
import SingleDatePicker from '@/components/sort/SingleDatePicker';
import { mapState, mapMutations, mapGetters } from 'vuex';
import { addQuery } from '@/utils/helpers';
import ContractTypeForm from '@/components/blocks/ContractTypeForm';
import moment from 'moment';

const errors = () => ({
  number: null,
  date: null,
  amount: null,
  // VatIncluded: null,
  type: null,
  subjectType: null,
  global: [],
});

export default {
  name: 'AddInitialContract',
  components: {
    ButtonElement,
    // Selector,
    SingleDatePicker,
    ContractTypeForm,
  },
  mixins: [formValidate, numberWithSpaces],
  data() {
    return {
      ContractTypeKeys,
      ContractVariant,
      ContractType,
      VatType,
      errors: errors(),
      loading: false,
    };
  },
  computed: {
    ...mapState('InitialContracts', ['form', 'initialContracts']),
    ...mapGetters('Clients', ['getClientById']),
    additionalAgreementOptions() {
      return this.initialContracts.map((initialContract) => ({
        id: initialContract.id,
        name: initialContract.number,
      }));
    },
    getClientId() {
      return this.$route.query.clientId;
    },
    isBtnDisabled() {
      const alwaysRequired =
        this.form.type &&
        this.form.date &&
        this.form.contractorId &&
        this.form.clientId &&
        this.form.number;

      if (this.form.type === ContractTypeKeys.SERVICE_AGREEMENT) {
        return !(alwaysRequired && this.form.subjectType && this.form.date);
      }
      if (this.form.type === ContractTypeKeys.MEDIATION_CONTRACT) {
        return !(
          alwaysRequired &&
          this.form.actionType &&
          this.form.subjectType &&
          this.form.date &&
          this.form.isAgentActingForPublisher !== null
        );
      }
      if (this.form.type === ContractTypeKeys.ADDITIONAL_AGREEMENT) {
        return !(alwaysRequired && this.form.parentMainContractId && this.form.date);
      }

      return !alwaysRequired;
    },
  },
  methods: {
    ...mapMutations('InitialContracts', ['cleanForm', 'setForm']),
    openDialogAddingInitialClient(formName) {
      this.$store.commit('Dialog/setData', { label: 'activeDialog', data: 'AddClient' });
      this.$store.commit('Dialog/setData', { label: 'dialogVisible', data: true });
      addQuery('formName', formName, this.$route.query, this.$router);
    },
    createInitialContract() {
      this.loading = true;

      this.cleanErrors();

      const payload = {
        type: this.form.type,
        subjectType: this.form.subjectType,
        number: this.form.number || null,
        date: moment(this.form.date).format('YYYY-MM-DD'),
        amount: this.form.amount !== null ? Number(this.form.amount) : null,
        // VatIncluded: this.form.VatIncluded === 'WITH_VAT',
        clientId: this.form.clientId.id,
        contractorId: this.form.contractorId.id,
        finalContractId: this.$route.query.finalContractId,
        actionType: this.form.actionType,
        parentMainContractId: this.form.parentMainContractId,
        ...(this.form.isAgentActingForPublisher === AgentActingForPublisherTypeKeys.RR ||
          (this.form.isAgentActingForPublisher === AgentActingForPublisherTypeKeys.RD && {
            isAgentActingForPublisher:
              this.form.isAgentActingForPublisher === AgentActingForPublisherTypeKeys.RR,
          })),
      };

      this.$store
        .dispatch('InitialContracts/createInitialContract', payload)
        .then(() => {
          this.cleanForm();
          this.$store.commit('Dialog/setData', { label: 'dialogVisible', data: null });
          this.$notify({
            message: this.$t('new_app.success'),
            type: 'success',
          });

          this.$store.commit('Dialog/setData', {
            label: 'activeDialog',
            data: 'CheckingFinalContract',
          });
          this.$store.commit('Dialog/setData', { label: 'dialogVisible', data: true });
        })
        .catch((err) => {
          // const objErrors = JSON.parse(err.data.errors.replace('Mediascout error request:', ''))

          const objErrors = Object.prototype.hasOwnProperty.call(err, 'Mediascout error request')
            ? JSON.parse(JSON.stringify(err).replace('Mediascout error request:', ''))
            : JSON.parse(JSON.stringify(err));

          objErrors.ErrorItems.map((errorItem) => {
            if (errorItem.PropertyName) {
              this.errors[errorItem.PropertyName] = [
                ...(this.errors[errorItem.PropertyName] || []),
                errorItem.ErrorMessage,
              ];
            } else {
              this.errors.global = [...this.errors.global, errorItem.ErrorMessage];
              this.$notify({
                message: errorItem.ErrorMessage,
                type: 'error',
              });
            }
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },
    cleanErrors() {
      this.errors = errors();
    },
    closeDialog() {
      this.cleanForm();
      this.$store.commit('Dialog/setData', { label: 'dialogVisible', data: false });
    },
    changeContractTypeForm({ name, value }) {
      this.setForm({ formName: name, formValue: value });
    },
  },
  mounted() {
    if (this.getClientId) {
      const client = this.getClientById(this.getClientId);
      this.setForm({ formName: 'contractorId', formValue: client });
    }
  },
};
</script>

<style lang="scss">
@import '@/assets/styles/helpers/variables';
@import '@/assets/styles/helpers/mixin';

.form-input--full .form-input__label {
  font-size: 1.2rem;
  line-height: 1.4rem;
  top: 0.6rem;
}

.add-initial-contract {
  background: #fff;
  color: #000;
  min-height: 100dvh;
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  &__date-picker {
    width: 100%;
    background: $basicWhite;
  }

  &__input-icon {
    position: absolute;
    right: 1.5rem;
    top: 1.5rem;
  }

  &__group-btns {
    display: flex;
    gap: 0.8rem;
    margin-top: 2rem;
    flex-direction: column;
  }

  &__btns-wrapper {
    display: flex;
    gap: 0.8rem;
  }

  &__save-btn {
    width: 17.4rem;
  }

  &__cancel-btn {
    width: 13.7rem;
  }

  textarea {
    font-family: 'Inter';
  }

  &__title {
    font-weight: 700;
    font-size: 4rem;
    line-height: 4.7rem;
    margin-bottom: 6.5rem;
    color: #000;
  }

  &__content {
    padding: 7rem;
    min-height: 100dvh;
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }

  .selector__content {
    background: none;
    border: 1px solid #bfc2c6;
  }

  .selector__title {
    font-size: 1.6rem;
    color: #878b93;
  }
  &__input {
    .selector__content {
      width: 100%;
    }
  }

  .button {
    height: 5rem;
  }

  &__step {
    margin-bottom: 6rem;

    &:last-of-type {
      margin-bottom: 0;
    }

    &-title {
      font-weight: 700;
      font-size: 2.2rem;
      line-height: 2.4rem;
      color: #333333;
      margin-bottom: 2rem;
    }

    &-content {
      .form-input {
        width: 100%;
        max-width: 35rem;

        @include below($sm) {
          max-width: 100%;
        }
      }
    }

    &-error {
      color: $redLight;
      position: absolute;
      left: 6rem;
    }
  }
}

@include below(993px) {
  .add-initial-contract__title {
    font-size: 22px;
    line-height: 1.3;
    margin-bottom: 30px;
  }

  .add-initial-contract__step {
    margin-bottom: 30px;
  }

  .add-initial-contract__final,
  .add-initial-contract__content {
    padding: 15px;
  }
}

@include below(769px) {
  .add-initial-contract__final {
    .button {
      width: 100%;
      margin-top: 10px;
    }
  }
}
</style>
